import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: null,
    externalProvider: null,
    currentFiles: [],
    currentChain: null,
    currentChainBatch: null,
    remoteConfig: null,
    currentTheme: null,
    chainsToSign: null
  },

  getters: {
    isSignedIn: state => !!state.currentUser,
    hasRole: state => role => state.currentUser && state.currentUser.roles.includes(role)
  },

  mutations: {
    setCurrentUser(state, currentUser) {
      if (currentUser && currentUser.roles) {
        currentUser.roles.push('user')
      }
      state.currentUser = currentUser
    },

    removeCurrentUser(state) {
      state.currentUser = null
    },

    setExternalProviderDetails(state, provider) {
      state.externalProvider = provider
    },

    removeExternalProviderDetails(state) {
      state.externalProvider = null
    },

    setCurrentFiles(state, files) {
      state.currentFiles = Array.isArray(files) ? [...files] : []
    },

    addCurrentFile(state, file) {
      state.currentFiles = [...state.currentFiles, file]
    },

    removeCurrentFileAtIndex(state, index) {
      const updated = [...state.currentFiles]
      updated.splice(index, 1)
      state.currentFiles = updated
    },

    removeCurrentFiles(state) {
      state.currentFiles = []
    },

    setCurrentChain(state, newFile) {
      state.currentChain = newFile
    },
    removeCurrentChain(state) {
      state.currentChain = null
    },
    setCurrentChainBatch(state, batch) {
      state.currentChainBatch = batch
    },
    advanceCurrentChainBatch(state) {
      if (state.currentChainBatch && typeof state.currentChainBatch.index === 'number') {
        state.currentChainBatch.index += 1
      }
    },
    removeCurrentChainBatch(state) {
      state.currentChainBatch = null
    },
    setRemoteConfig(state, config) {
      state.remoteConfig = config
    },
    removeRemoteConfig(state) {
      state.remoteConfig = null
    },

    setCurrentTheme(state, currentTheme) {
      state.currentTheme = currentTheme
    },
    removeCurrentTheme(state) {
      state.currentTheme = null
    },
    setChainsToSign(state, chains) {
      state.chainsToSign = [...chains]
    },
    removeChainsToSign(state) {
      state.chainsToSign = null
    }
  },

  plugins: [
    createPersistedState({
      paths: ['externalProvider'] // Persist only this property
    })
  ]
})

export default store
